function openReferrals(memberId) {
  window.open(`/members/${memberId}/referral/provider`)
}
export default openReferrals;
